import React from 'react';
import {connect} from 'react-redux';
import {pushState} from 'react-router';
import Auth from '../modules/Auth.js';
import axios from 'axios';
import {bindActionCreators} from 'redux';
import {setCurrentUser} from '../actions/Login.js';
import Loading from './Loading.js';
import GeneralHandler from '../modules/General';
import Intercom from 'react-intercom';
import Raven from 'raven-js';
import Helpers from '../../../lib/helpers/index.js';

export function requireAuthentication(Component) {

    class AuthenticatedComponent extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                isLoading:true,
                didIdentify:false,
            };

            this.shouldRender = this.shouldRender.bind(this);
        }

        componentWillMount () {
            if(!this.props.location.query.next) {
                this.getAuthentication(this.props);
            }
        }


        getAuthentication(props) {
            if(props.auth.isAuthenticated) {
                this.setState({isLoading:false});
                return true;
            }

            let auth = Auth.authenticate(Auth.getToken(),this.props.router.params.account_id);

            if(auth.action == 'redirect') {
                this.props.router.push(GeneralHandler.Link(auth.url));
                return;
            }

            GeneralHandler.fetchGeneral().then(res => {
                if(this.props.auth.user.is_staff && !Auth.isStaff()) {
                    localStorage.setItem('is_staff', true);
                }
                this.setState({isLoading:false});
            })
            .catch(res => {


                if(!this.props.router.isActive('/login') && res.response) {
                    this.forceLogin();
                }else{console.dir(res);
                    Raven.captureException(res)
                }
            });
        }

        componentWillReceiveProps (nextProps) {
            return;
            if(this.props.route.path != nextProps.route.path) {
                return true;
            }

            this.getAuthentication(nextProps);
        }

        forceLogin() {

            Helpers.redirectToNewAdmin();

            return;
            Auth.authenticate(false);
            this.props.setCurrentUser(false);
            let redirectAfterLogin = this.props.location.pathname;
            this.props.router.push('/login?next='+redirectAfterLogin);


        }

        shouldRender = () => {

            if(this.props.location.pathname === '/login') {
                this.forceLogin();
                return;
            }

            if(this.props.auth.isAuthenticated === true) {

                if(this.state.didIdentify === false) {
                    if(typeof zE === 'function') {
                        zE(()=> {
                            zE.identify({name: this.props.auth.user.firstname+' '+this.props.auth.user.lastname, email: this.props.auth.user.email});
                        });

                        this.setState({
                            didIdentify: true,
                        });
                    }
                }


                if(this.props.router.isActive('/login')) {
                    return <Component {...this.props}/>;
                }else{
                    if(this.state.isLoading) {
                        return <Loading withLogo={true} error={false} />
                    }else{
                        return  <Component {...this.props}/>;
                    }
                }
            }else{
                if(this.props.router.isActive('/login')) {
                     return  <Component {...this.props}/>;
                }else{
                    return <Loading withLogo={true} error={false} />
                }

            }
        }

        render () {
            return (
                <div className="full-height">
                    {this.shouldRender()}
                </div>
            )

        }
    }

    const mapStateToProps = (state) => ({
        auth:state.auth,
        general:state.general
    });


    const mapDispatchToProps = (dispatch) => {
        return bindActionCreators({setCurrentUser},dispatch)
    }

    AuthenticatedComponent = connect(mapStateToProps,mapDispatchToProps)(AuthenticatedComponent);
    return AuthenticatedComponent;

}



// WEBPACK FOOTER //
// ./components/requireAuthentication.js